import styles from "../../styles/chat.module.scss";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import Router, { useRouter } from "next/router";
import http from "../../http";
import { ShowMessage } from "../ShowMessage/ShowMessage";
import { useTheme, useUserInfo } from "../../context/ThemeContext";
import { Button, Input, Menu, message, Popconfirm, Tooltip } from "antd";
import React from "react";
import SettingModal from "../setting/SettingModal";
import { useCommonData } from "../../layout/ELayout";
import {
  CodeOutlined,
  FileWordOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import { wikiDisabled } from "../../version";
function LeftPannel(
  props: {
    createNewChat?: () => void;
    chatItemClick?: (id: string) => void;
    settingClick?: () => void;
    logOut?: () => void;
    handleLogin?: () => void;
    setLoading?: (loading: boolean) => void;
    onfoldClick?: (isFold: boolean) => void;
    menu?: JSX.Element;
    rightTopBtn?: JSX.Element;
    rightTopTooltip?: JSX.Element | string;
    title?: string;
  },
  ref: any
) {
  const router = useRouter();
  const {
    createNewChat,
    chatItemClick,
    settingClick,
    setLoading,
    onfoldClick,
    logOut,
    handleLogin,
    menu,
    rightTopBtn,
    rightTopTooltip,
    title = "Eagle",
  } = props;
  const { commonData, changeCommonData } = useCommonData();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // 是否折叠左边菜单
  const [chatList, setChatList] = useState<any[]>([]); //聊天列表
  const [currentList, setCurrentList] = useState("" as any);
  const { theme, toggleTheme } = useTheme();
  const { userInfo, toggleUserInfo } = useUserInfo();
  const pannel = useRef<any>(null);
  const originalList = useRef<any[]>([]);
  const [seachValue, setSeachValue] = useState("");
  const { Search } = Input;
  const [layoutValue, setLayoutValue] = useState(
    localStorage.getItem("layout") || "/"
  );
  // 添加状态变量控制是否显示Genius选项
  const [showGenius, setShowGenius] = useState(false);
  useImperativeHandle(ref, () => {
    return {
      getChatList: () => {
        const token = localStorage.getItem("token");
        token && getChatList();
      },
      onFlod: (status: boolean) => {
        setIsSidebarCollapsed(status);
      },
    };
  });
  useEffect(() => {
    // 检查当前网站地址，如果是eagle.capitalren.com则不显示Genius选项
    if (typeof window !== "undefined") {
      const hostname = window.location.hostname;
      if (hostname === "eagle.capitalren.com") {
        setShowGenius(false);
      } else {
        setShowGenius(true);
      }
    }
  }, []);
  useEffect(() => {
    if (router.isReady) {
      if (router.pathname.includes("/wiki")) {
        setLayoutValue("/wiki");
      } else if (router.pathname.includes("/genius")) {
        setLayoutValue("/genius");
      } else {
        setLayoutValue("/");
      }
    }
  }, [router]);
  useEffect(() => {
    onfoldClick?.(isSidebarCollapsed);
  }, [isSidebarCollapsed]);

  useEffect(() => {
    if (router.isReady) {
      setCurrentList(router.query.thread_id);
    }
  }, [router]);

  // 获取对话列表
  const getChatList = (type: string = "load") => {
    http
      .get(`/api/v1/chat/chatlist`)
      .then((data: any) => {
        if (data.status) {
          originalList.current = data.data;
          onSearch();
        } else {
          ShowMessage.error(data.message);
        }
        if (type === "del") {
          setLoading?.(false);
        }
      })
      .finally(() => {
        setLoading?.(false);
      });
  };
  const deleteChat = (uuid: any) => {
    setLoading?.(true);
    http
      .delete(`/api/v1/chat/chat/${uuid}`)
      .then((data: any) => {
        if (data.status) {
          getChatList("del");
        } else {
          ShowMessage.error(data.message);
          setLoading?.(false);
        }
      })
      .catch(() => {
        setLoading?.(false);
      });
  };
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  const onSearch = (value: string = "") => {
    const newList = originalList.current.filter((item: any) => {
      return item.thread_name.toLowerCase().includes(value.toLowerCase());
    });
    setChatList([...newList]);
  };
  const checkLogin = () => {
    const token = localStorage.getItem("token");
    if (!userInfo.login || !token) {
      changeCommonData({ showLogin: true });
      return false;
    }
    return true;
  };
  return (
    <>
      <div
        className={`${styles.pannel} ${
          isSidebarCollapsed ? styles.collapsed : ""
        }`}
        ref={pannel}
      >
        <div
          className={styles.sidebarControls}
          style={
            isSidebarCollapsed
              ? { padding: "30px 10px", flexDirection: "column", height: 130 }
              : {}
          }
        >
          <Tooltip
            placement={isSidebarCollapsed ? "right" : "bottom"}
            title={isSidebarCollapsed ? "展开侧栏" : "收起侧栏"}
          >
            <div className={styles.toggleSidebar} onClick={toggleSidebar}>
              {isSidebarCollapsed ? (
                <svg
                  className={styles.icon}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M8.857 3h6.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961.058.708.058 1.582.058 2.666v3.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487C17.1 21 16.227 21 15.143 21H8.857c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.96-.487a5 5 0 0 1-2.186-2.185c-.302-.592-.428-1.232-.487-1.961C1.5 15.6 1.5 14.727 1.5 13.643v-3.286c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 4.23 3.544c.592-.302 1.233-.428 1.961-.487C6.9 3 7.773 3 8.857 3M6.354 5.051c-.605.05-.953.142-1.216.276a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216-.05.617-.051 1.41-.051 2.546v3.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h.6V5h-.6c-1.137 0-1.929 0-2.546.051M11.5 5v14h3.6c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546v-3.2c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311c-.263-.134-.611-.226-1.216-.276C17.029 5.001 16.236 5 15.1 5zM5 8.5a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1M5 12a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1"
                    clipRule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  className={styles.icon}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M8.857 3h6.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961.058.708.058 1.582.058 2.666v3.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487C17.1 21 16.227 21 15.143 21H8.857c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.96-.487a5 5 0 0 1-2.186-2.185c-.302-.592-.428-1.232-.487-1.961C1.5 15.6 1.5 14.727 1.5 13.643v-3.286c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 4.23 3.544c.592-.302 1.233-.428 1.961-.487C6.9 3 7.773 3 8.857 3M6.354 5.051c-.605.05-.953.142-1.216.276a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216-.05.617-.051 1.41-.051 2.546v3.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h.6V5h-.6c-1.137 0-1.929 0-2.546.051M11.5 5v14h3.6c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546v-3.2c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311c-.263-.134-.611-.226-1.216-.276C17.029 5.001 16.236 5 15.1 5zM5 8.5a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1M5 12a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1"
                    clipRule="evenodd"
                  ></path>
                </svg>
              )}
            </div>
          </Tooltip>
          {!isSidebarCollapsed && (
            <div className={styles.logoContainer}>
              <span className={styles.textBlob}>CodeBot</span>
              <span className={styles.text}>{title}</span>
            </div>
          )}
          <div className={styles.btns}>
            <Tooltip
              placement={isSidebarCollapsed ? "right" : "bottom"}
              title={rightTopTooltip || "新建对话"}
            >
              {rightTopBtn ? (
                rightTopBtn
              ) : (
                <div
                  className={styles.editIcon}
                  onClick={() => {
                    if (!checkLogin()) {
                      return;
                    }
                    getChatList();
                    createNewChat?.();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    className="icon-xl-heavy"
                  >
                    <path d="M15.673 3.913a3.121 3.121 0 1 1 4.414 4.414l-5.937 5.937a5 5 0 0 1-2.828 1.415l-2.18.31a1 1 0 0 1-1.132-1.13l.311-2.18A5 5 0 0 1 9.736 9.85zm3 1.414a1.12 1.12 0 0 0-1.586 0l-5.937 5.937a3 3 0 0 0-.849 1.697l-.123.86.86-.122a3 3 0 0 0 1.698-.849l5.937-5.937a1.12 1.12 0 0 0 0-1.586M11 4A1 1 0 0 1 10 5c-.998 0-1.702.008-2.253.06-.54.052-.862.141-1.109.267a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216C5.001 8.471 5 9.264 5 10.4v3.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h3.2c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.126-.247.215-.569.266-1.108.053-.552.06-1.256.06-2.255a1 1 0 1 1 2 .002c0 .978-.006 1.78-.069 2.442-.064.673-.192 1.27-.475 1.827a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487C15.6 21 14.727 21 13.643 21h-3.286c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.96-.487a5 5 0 0 1-2.186-2.185c-.302-.592-.428-1.233-.487-1.961C3 15.6 3 14.727 3 13.643v-3.286c0-1.084 0-1.958.058-2.666.06-.729.185-1.369.487-1.961A5 5 0 0 1 5.73 3.545c.556-.284 1.154-.411 1.827-.475C8.22 3.007 9.021 3 10 3A1 1 0 0 1 11 4"></path>
                  </svg>
                </div>
              )}
            </Tooltip>
          </div>
        </div>
        <div
          className={styles.sidebar}
          style={{ height: isSidebarCollapsed ? "100%" : "auto" }}
        >
          <Menu
            mode="inline"
            selectedKeys={[layoutValue]}
            style={{
              border: "none",
              backgroundColor: "transparent",
            }}
            inlineCollapsed={isSidebarCollapsed}
            items={[
              {
                key: "/",
                icon: <MessageOutlined />,
                label: "新对话",
              },
              {
                key: "/wiki",
                icon: <FileWordOutlined />,
                label: wikiDisabled ? "生成项目文档(正在维护)" : "生成项目文档",
                disabled: wikiDisabled,
              },
              ...(showGenius
                ? [
                    {
                      label: "Genius",
                      key: "/genius",
                      icon: <CodeOutlined />,
                    },
                  ]
                : []),
            ]}
            onClick={({ key }) => {
              setLoading?.(true);
              setLayoutValue(key);
              localStorage.setItem("layout", key);
              if (key === "/wiki") {
                if (commonData.wikiList.length) {
                  router
                    .push(`/wiki/${commonData.wikiList[0]?.key || ""}`)
                    .then(() => {
                      setLoading?.(false);
                    });
                  return;
                }
                router.push(key).then(() => {
                  setLoading?.(false);
                });
              } else if (key === "/") {
                if (router.pathname !== key) {
                  router.push(key).then(() => {
                    setLoading?.(false);
                  });
                }
                if (!checkLogin()) {
                  setLoading?.(false);
                  return;
                }
                getChatList();
                createNewChat?.();
              } else {
                router.push(key).then(() => {
                  setLoading?.(false);
                });
              }
              setLoading?.(false);
            }}
          />
        </div>
        {!isSidebarCollapsed &&
          (menu ? (
            <>
              <div className={styles.sliderline}></div>
              {menu}
            </>
          ) : !userInfo.login ? (
            <div className={styles.notLoginBox}>
              <div className={styles.historyIcon} />
              <div className={styles.historyText}>登陆后同步历史</div>
            </div>
          ) : (
            <div className={styles.contentBox}>
              <div className={styles.sliderline}></div>
              <Search
                placeholder="搜索聊天..."
                allowClear
                onSearch={onSearch}
                value={seachValue}
                onChange={(e) => {
                  setSeachValue(e.target.value);
                  if (e.target.value.length <= 0) {
                    onSearch();
                  }
                }}
                style={{ padding: "0 24px", marginBottom: 8 }}
              />
              <div className={styles.fileBox}>
                <div className={styles.fileList}>
                  {chatList.map((item: any, index: number) => {
                    return (
                      <div key={index} className={styles.fileItem}>
                        <div
                          onClick={() => {
                            setCurrentList(item.thread_id);
                            chatItemClick?.(item.thread_id);
                          }}
                          title={item.thread_name ? item.thread_name : "未知"}
                          className={`${styles.fileTitle} ellipsis ${
                            item.thread_id == currentList ? styles.active : ""
                          }`}
                          key={item.uuid}
                        >
                          {item.thread_name ? item.thread_name : "新对话"}
                        </div>
                        <Popconfirm
                          placement="right"
                          title={"确定删除对话？"}
                          description={"删除后，聊天记录将不可恢复。"}
                          onConfirm={() => {
                            deleteChat(item.uuid);
                          }}
                          okText="确认"
                          cancelText="取消"
                        >
                          <span className={styles.delete}></span>
                        </Popconfirm>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        <div className={styles.line}></div>
        {userInfo?.phone_number && localStorage.getItem("token") ? (
          <div
            className={styles.userInfo}
            style={
              isSidebarCollapsed
                ? { padding: "30px 10px", flexDirection: "column", height: 130 }
                : {}
            }
          >
            <SettingModal tabKey="user">
              <Tooltip
                placement={isSidebarCollapsed ? "right" : "top"}
                title={"设置"}
              >
                <div className={styles.btnBox}>
                  <div
                    className={`${styles.setting} ${
                      theme === "light"
                        ? styles.settingLight
                        : styles.settingDark
                    }`}
                  ></div>
                </div>
              </Tooltip>
            </SettingModal>
            {!isSidebarCollapsed && (
              <div className={styles.infoContent}>
                <p className={styles.name}>{userInfo.accaccount_type_name}</p>
                <p className={styles.slide}>|</p>
                {userInfo.subscription_expired && (
                  <p className={styles.time}>
                    {userInfo.subscription_expired ? "截止至：" : ""}
                    {userInfo.subscription_expired}
                  </p>
                )}
                {!userInfo.subscription_expired && (
                  <SettingModal
                    tabKey={
                      router.pathname.includes("/wiki") ? "points" : "pay"
                    }
                  >
                    {router.pathname.includes("/wiki") ? (
                      <p className={styles.upgrade}>充值积分</p>
                    ) : (
                      <p className={styles.upgrade}>升级到会员</p>
                    )}
                  </SettingModal>
                )}
              </div>
            )}
            <Tooltip
              placement={isSidebarCollapsed ? "right" : "top"}
              title={"登出"}
            >
              <div className={styles.btnBox}>
                <div
                  onClick={() => {
                    logOut?.();
                    localStorage.removeItem("token");
                    toggleUserInfo({ login: false });
                    router.replace("/");
                  }}
                  className={`${styles.exitBtn} ${
                    theme == "light" ? styles.exitLight : styles.exitDark
                  }`}
                ></div>
              </div>
            </Tooltip>
          </div>
        ) : (
          <Button
            type="primary"
            shape="round"
            size="large"
            style={!isSidebarCollapsed ? { margin: 16 } : { margin: "16px 0" }}
            onClick={handleLogin}
          >
            {!isSidebarCollapsed ? "立即登录" : "登录"}
          </Button>
        )}
      </div>
    </>
  );
}
export default forwardRef(LeftPannel);
